import { TextElement } from '../types/storybook';

export interface TextBoxStyle {
  id: string;
  name: string;
  preview: string; // Emoji or symbol for preview
  style: Partial<TextElement>;
}

export const TEXT_BOX_STYLES: TextBoxStyle[] = [
  {
    id: 'normal',
    name: 'Normal',
    preview: '�',
    style: {
      backgroundColor: 'transparent',
      backgroundOpacity: 1,
      borderColor: '#000000',
      borderWidth: 0,
      borderStyle: 'solid'
    }
  },
  {
    id: 'speech-bubble',
    name: 'Speech Bubble Left',
    preview: '💬',
    style: {
      backgroundColor: '#ffffff',
      backgroundOpacity: 1,
      borderColor: '#000000',
      borderWidth: 2,
      borderStyle: 'solid'
    }
  },
  {
    id: 'speech-bubble-right',
    name: 'Speech Bubble Right',
    preview: '🗨️',
    style: {
      backgroundColor: '#ffffff',
      backgroundOpacity: 1,
      borderColor: '#000000',
      borderWidth: 2,
      borderStyle: 'solid'
    }
  },
  {
    id: 'shout-bubble-left',
    name: 'Shout Bubble Left',
    preview: '💢',
    style: {
      backgroundColor: '#ffffff',
      backgroundOpacity: 1,
      borderColor: '#000000',
      borderWidth: 3,
      borderStyle: 'solid'
    }
  },
  {
    id: 'shout-bubble-right',
    name: 'Shout Bubble Right',
    preview: '📢',
    style: {
      backgroundColor: '#ffffff',
      backgroundOpacity: 1,
      borderColor: '#000000',
      borderWidth: 3,
      borderStyle: 'solid'
    }
  },
  {
    id: 'whisper-bubble-left',
    name: 'Whisper Bubble Left',
    preview: '🤫',
    style: {
      backgroundColor: '#f0f0f0',
      backgroundOpacity: 0.9,
      borderColor: '#666666',
      borderWidth: 1,
      borderStyle: 'dashed'
    }
  },
  {
    id: 'whisper-bubble-right',
    name: 'Whisper Bubble Right',
    preview: '🤐',
    style: {
      backgroundColor: '#f0f0f0',
      backgroundOpacity: 0.9,
      borderColor: '#666666',
      borderWidth: 1,
      borderStyle: 'dashed'
    }
  },
  {
    id: 'rectangular-bubble-left',
    name: 'Box Bubble Left',
    preview: '📦',
    style: {
      backgroundColor: '#fffacd',
      backgroundOpacity: 1,
      borderColor: '#000000',
      borderWidth: 2,
      borderStyle: 'solid'
    }
  },
  {
    id: 'rectangular-bubble-right',
    name: 'Box Bubble Right',
    preview: '📋',
    style: {
      backgroundColor: '#fffacd',
      backgroundOpacity: 1,
      borderColor: '#000000',
      borderWidth: 2,
      borderStyle: 'solid'
    }
  },
  {
    id: 'thought-bubble-left',
    name: 'Thought Bubble Left',
    preview: '💭',
    style: {
      backgroundColor: '#ffffff',
      backgroundOpacity: 1,
      borderColor: '#000000',
      borderWidth: 2,
      borderStyle: 'solid'
    }
  },
  {
    id: 'thought-bubble-right',
    name: 'Thought Bubble Right',
    preview: '🤔',
    style: {
      backgroundColor: '#ffffff',
      backgroundOpacity: 1,
      borderColor: '#000000',
      borderWidth: 2,
      borderStyle: 'solid'
    }
  }
];

export const getTextBoxStyle = (styleId: string): TextBoxStyle | undefined => {
  return TEXT_BOX_STYLES.find(style => style.id === styleId);
};

export const applyStyleToText = (
  currentText: Partial<TextElement>, 
  style: TextBoxStyle
): Partial<TextElement> => {
  return {
    // Start with current text
    ...currentText,
    // Track which style is applied
    styleId: style.id,
    // Apply style properties
    backgroundColor: style.style.backgroundColor,
    backgroundOpacity: style.style.backgroundOpacity,
    borderColor: style.style.borderColor,
    borderWidth: style.style.borderWidth,
    borderStyle: style.style.borderStyle,
    // Apply color and font only if style specifies them
    color: style.style.color !== undefined ? style.style.color : currentText.color,
    fontFamily: style.style.fontFamily !== undefined ? style.style.fontFamily : currentText.fontFamily
  };
};
